import { orangeGradientFontStyle } from '../../../fontStyles';
import BasePopup from '../popupWin/BasePopup';
import { gsap } from 'gsap';
import EntryPoint from 'Engine/EntryPoint';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import BaseMoneyFormat from 'Engine/base/moneyFormat/MoneyFormat';
import SoundManager from 'Engine/soundManager/SoundManager';
import eSoundType from '../../../sounds/eSoundType';
import eEventTypes from '../../../enums/eEventTypes';

export default class ControllerFreespinsEnd extends BasePopup {
  constructor(data, displayData) {
    super(data, displayData);
    this.alpha = 0;
    this._progress = 0;
    this.init()
  }
  init() {
    super.init();
    this.totalWinText = this.wrapper.getChildByName('freespins_popup_end_total_win')
    this.textFieldTotalWin = this.wrapper.getChildByName('amount')
    this.setTextStile()
  }
  setTextStile() {
    this.totalWinText.style = { ...this.totalWinText.style, ...orangeGradientFontStyle }
    this.textFieldTotalWin.style = { ...this.textFieldTotalWin.style, ...orangeGradientFontStyle }
  }

  onShow() {
    super.onShow();
    this.progress = 0;
    const arrForDecimals = BaseMoneyFormat.formatCurrency(EntryPoint.GameModel.freespinsTotalWin, EntryPoint.GameModel.currencyInfo.decimals).split('.');
    this.decimalsForAnimation = arrForDecimals[1] ? arrForDecimals[1].length : 0;
    gsap.to(this, { progress: 1, duration: 2, onComplete: () => {
        this.textFieldTotalWin.text = BaseMoneyFormat.format(EntryPoint.GameModel.freespinsTotalWin);
        setTimeout(() => {
          this.hide();
        }
      ,2000)
      }})
    SoundManager.play(eSoundType.EST_FS_TOTAL_WIN, 0.5, false, 'winning');
  }
  onHide() {
    super.onHide();
    GlobalDispatcher.dispatch(eEventTypes.EET_FREESPINS_END__ON_COMPLETE)
  }

  set progress(value) {
    this._progress = value;
    this.totalWin = EntryPoint.GameModel.freespinsTotalWin * value;
  }

  get progress() {
    return this._progress;
  }

  set totalWin(value) {
    this._totalWin = value
    this.textFieldTotalWin.text = `${value.toFixed(this.decimalsForAnimation)} ${EntryPoint.GameModel.currencyInfo.currency}`;
  }
  get totalWin() {
    return this._totalWin;
  }
}
